import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aec7a07a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row m-4" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pb-3" }, "Click the link below to install OTC Pro for Windows:", -1))
const _hoisted_4 = { class: "icon-box mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "download-link",
    href: "https://equityfeed.s3.us-west-2.amazonaws.com/scanz/install/win/scanz.exe"
  }, "Download OTC Pro on Windows 64-bit"),
  /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "instructions-header" }, "Installation Instructions"),
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, "Download the OTC Pro Platform"),
      /*#__PURE__*/_createElementVNode("li", null, "Double click the .exe file to launch the installer"),
      /*#__PURE__*/_createElementVNode("li", null, "Click \"Next\" to proceed through the installation"),
      /*#__PURE__*/_createElementVNode("li", null, " Launch OTC Pro from the Windows Start menu or via the desktop shortcut ")
    ])
  ])
], -1))
const _hoisted_6 = { class: "row m-4" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pb-3" }, "Click the link below to install OTC Pro for Mac OS:", -1))
const _hoisted_9 = { class: "icon-box mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "download-link",
    href: "https://equityfeed.s3.us-west-2.amazonaws.com/scanz/install/mac/scanz.dmg"
  }, "Download OTC Pro on Mac 64-bit"),
  /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "instructions-header" }, "Installation Instructions"),
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, "Download the OTC Pro Platform"),
      /*#__PURE__*/_createElementVNode("li", null, "Double click the .dmg file to launch the installer"),
      /*#__PURE__*/_createElementVNode("li", null, "Click \"Next\" to proceed through the installation"),
      /*#__PURE__*/_createElementVNode("li", null, "Launch OTC Pro from the Applications folder or via the desktop shortcut")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_collapsable_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'windows'] })
              ]),
              _hoisted_5
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_collapsable_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'apple'] })
              ]),
              _hoisted_10
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}